import { apiFetch } from "@/integrations/backend/client";

export type Assessment = {
  id: string;
  name: string;
  description: string;
  typeform_url: string;
  is_deleted: boolean;
  deleted_at: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type ClientAssessment = Pick<
  Assessment,
  "id" | "name" | "description" | "typeform_url" | "created_at" | "updated_at"
>;

export async function listAssessments(options?: { include_deleted?: boolean }): Promise<Assessment[]> {
  const includeDeleted = Boolean(options?.include_deleted);
  const qs = includeDeleted ? "?include_deleted=true" : "";
  const res = await apiFetch(`/api/v1/admin/assessments${qs}`, { method: "GET" });
  if (!res.ok) throw new Error(`assessments_list_failed:${res.status}`);
  return (await res.json()) as Assessment[];
}

export async function listClientAssessments(): Promise<ClientAssessment[]> {
  const res = await apiFetch("/api/v1/assessments", { method: "GET" });
  if (!res.ok) throw new Error(`assessments_client_list_failed:${res.status}`);
  return (await res.json()) as ClientAssessment[];
}

export async function getClientAssessment(id: string): Promise<ClientAssessment> {
  const res = await apiFetch(`/api/v1/assessments/${encodeURIComponent(id)}`, { method: "GET" });
  if (!res.ok) throw new Error(`assessments_client_detail_failed:${res.status}`);
  return (await res.json()) as ClientAssessment;
}

export async function createAssessment(input: {
  name: string;
  description: string;
  typeform_url: string;
}): Promise<Assessment> {
  const res = await apiFetch("/api/v1/admin/assessments", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`assessment_create_failed:${res.status}`);
  return (await res.json()) as Assessment;
}

export async function updateAssessment(
  id: string,
  patch: Partial<Pick<Assessment, "name" | "description" | "typeform_url" | "is_deleted">>
): Promise<Assessment> {
  const res = await apiFetch(`/api/v1/admin/assessments/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(`assessment_update_failed:${res.status}`);
  return (await res.json()) as Assessment;
}

export async function reactivateAssessment(id: string): Promise<Assessment> {
  return await updateAssessment(id, { is_deleted: false });
}

export async function deleteAssessment(id: string): Promise<void> {
  const res = await apiFetch(`/api/v1/admin/assessments/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`assessment_delete_failed:${res.status}`);
}

